<div class="square-revenue-dialog" mat-dialog-content>
    <h2>Cash Revenue</h2>
    
    <div class="container">
        <div class="transfers" *ngFor="let transfer of transaction.cashDeposit; let i = index">
            <div class="invoice"><input matInput maxlength="24" [ngModel]="truncateTransferNote(transfer.invoice)" (ngModelChange)="updateTransferInvoice(transfer, $event)"></div>
            <div class="amount"><ap-money [(amount)]="transfer.amount" (amountChange)="save(false)"></ap-money></div>
            <div class="actions">
                <button (click)="deleteTransfer(i)" mat-button>Delete</button>
            </div>
        </div>
        <div class="transfers">
            <div class="invoice"><input matInput maxlength="24" [ngModel]="truncateTransferNote(transferToAddInv)" (ngModelChange)="updateTransferToAddInv($event)"></div>
            <div class="amount"><ap-money [(amount)]="transferToAddAmount"></ap-money></div>
            <div class="actions">
                <button (click)="addTransfer()" mat-button>Add</button>
            </div>
        </div>
        <div class="total">{{getTotal() | human}} / {{transaction.amount | human}}</div>
    </div>
</div>

<div mat-dialog-actions>
    <button (click)="save()" mat-raised-button>Save</button>
    <button (click)="commit()" mat-raised-button>Commit</button>
    <button (click)="close(null)" mat-raised-button>Cancel</button>
</div>
